import React from "react";
import { DA_FeatureHandler } from "../../../helpers/FeatureHandler.helper";
import { V1 } from "./v1/ReceiptV1.component";

const featureName = "blockReceipt";
const versions = {
    v1: V1,
};

// eslint-disable-next-line unused-imports/no-unused-vars
export const DA_Receipt = React.forwardRef(({ version, ...props }: any, ref: any) => (
    <DA_FeatureHandler
        featureName={featureName}
        featureVersions={versions}
        version={version}
        {...props}
    />
));

DA_Receipt.displayName = "DA_Receipt";
